<template>
    <SlideSidebarContainer>
      <template v-slot:title>
        <span>Ferramentas</span>
      </template>
  
      <ToolsNavbar />
    </SlideSidebarContainer>
  </template>
  
  <script>
    import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'
    import ToolsNavbar from '@/components/layout/ToolsNavbar'
  
    export default {
      components: {
        ToolsNavbar,
        SlideSidebarContainer,
      },
    }
  </script>